<template>
    <button :class="className" :type="type" :disabled="disable" @click="$emit('clicked')">
        <template v-if="loading">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> {{ loadingTitle }}...
        </template>
        <template v-else>
            <i :class="icon" v-if="icon"></i> {{ title }}
        </template>
    </button>
</template>

<script>
export default {
    name: 'St_Button',
    props: {
        title: { required: true},
        icon: { default: null },
        loading: { default: false},
        disable: { default: false},
        className: { default: 'btn btn-primary'},
        type: {default: "button"},
        loadingTitle: { default: 'Loading' }
    }
};
</script>
